









































import Vue from "vue";
import Component from 'vue-class-component';
import StarIcon from 'vue-material-design-icons/Star.vue';

@Component({
    components: { StarIcon },
})
export default class DetalhesCobertura extends Vue {
    public image = require("@/assets/images/crash.svg");
    public readonly coberturas = [{
            label:   'R$ 100.000,00',
            value: 150,
            adesao: 350,
            app: 20000,
            morais: 20000,
            materiais:  30000,
            corporais:  30000,
        }, {
            label:   'R$ 150.000,00',
            value: 190,
            adesao: 350,
            app: 20000,
            morais: 30000,
            materiais:  60000,
            corporais:  40000,
        }, {
            label:   'R$ 200.000,00',
            value: 230,
            adesao: 350,
            app: 20000,
            morais: 30000,
            materiais: 110000,
            corporais:  40000,
        }, {
            label:   'R$ 300.000,00',
            value: 255,
            adesao: 400,
            app: 30000,
            morais: 40000,
            materiais: 180000,
            corporais:  50000,
        }, {
            label:   'R$ 400.000,00',
            value: 300,
            adesao: 400,
            app: 40000,
            morais: 40000,
            materiais: 250000,
            corporais:  70000,
        }, {
            label:   'R$ 500.000,00',
            value: 355,
            adesao: 400,
            app: 40000,
            morais: 40000,
            materiais: 300000,
            corporais: 120000,
        }, {
            label:   'R$ 600.000,00',
            value: 440,
            adesao: 500,
            app: 50000,
            morais: 50000,
            materiais: 350000,
            corporais: 150000,
        }, {
            label:   'R$ 700.000,00',
            value: 530,
            adesao: 500,
            app: 50000,
            morais: 50000,
            materiais: 400000,
            corporais: 200000,
        }, {
            label:   'R$ 800.000,00',
            value: 610,
            adesao: 500,
            app: 50000,
            morais: 50000,
            materiais: 450000,
            corporais: 250000,
        }, {
            label:   'R$ 900.000,00',
            value: 700,
            adesao: 500,
            app: 50000,
            morais: 50000,
            materiais: 500000,
            corporais: 300000,
        }, {
            label: 'R$ 1.000.000,00',
            value: 790,
            adesao: 500,
            app: 5000,
            morais: 50000,
            materiais: 550000,
            corporais: 350000,
        }
    ];

    get cobertura () {
        return this.$store.state.cotacao.valor_cobertura;
    }

    set cobertura (value) {
        const data = this.coberturas.find( (item) => item.value === value );
        if ( data !== undefined ) {
            this.$store.commit('SET_COBERTURA', data);
        }
    }
}
